// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__16_E8","title":"ClientReferral_title__1NQot","itemText":"ClientReferral_itemText___21pT"};